import React from 'react';
import PropTypes from 'prop-types';
import { SingleSelect } from '@els/els-react--select';
import Button from '@Components/Button';
import Input from '@Components/Input';
import ExportModalContentTooltip from './ExportModalContentTooltip';
import { EXPORT_ERRORS } from '../../ExportModalConstants';

import './ExportModalContentRange.scss';

function ExportModalContentRange({ data, formData, setRange, setRangeOptions, trackAdobeAnalyticsError, signIn, errors, parentParams }) {
  const { range } = formData;
  const { context } = parentParams;

  const mappedRange = { label: range.placeholder, value: range.placeholder };

  const mappedRangeOptions = data.ranges.map((rangeItem) => ({
    label: rangeItem.label + rangeItem.value,
    value: rangeItem.label + rangeItem.value,
  }));
  const handleRangeSelect = ({ value }) => {
    // eslint-disable-next-line no-shadow
    const index = mappedRangeOptions.findIndex((rangeItem) => rangeItem.value === value);
    setRange(index);
    trackAdobeAnalyticsError();
  };

  const isBioactivityVisualization = context === 'dpitems';

  return (
    <div className="exportModal__ranges">
      <div className="exportModal__content_row">
        <div className="exportModal__content_row_label">Range:</div>
        <div className="exportModal__content_row_value">
          <SingleSelect
            id="export-modal-content-dropdown-range"
            className="e2e-export-modal-content-dropdown-range"
            options={mappedRangeOptions}
            selectedOptions={mappedRange.value ? [mappedRange.value] : undefined}
            label="Select range"
            required
            onSelect={handleRangeSelect}
            size="small"
            shouldHideLabel
          />

          <div className="exportModal__ranges_messages errorMessage text-danger">
            {errors[EXPORT_ERRORS.RANGE_HIGH] && (
              <>
                {isBioactivityVisualization && (
                  <>
                    <span>{`The selected export range exceeds the limit of ${data.exportSizeLimit} substance and target results.`}</span>
                    <span>{`Please adjust your export range settings${
                      errors[EXPORT_ERRORS.RANGE_HIGH_ANONYMOUS_HINT] ? ' or sign-in/register to benefit from a higher export limit.' : '.'
                    }`}</span>
                  </>
                )}
                {!isBioactivityVisualization && (
                  <>
                    <span>{`The selected export range exceeds the limit of ${data.exportSizeLimit}.`}</span>
                    <span>{`Please adjust your export range settings${
                      errors[EXPORT_ERRORS.RANGE_HIGH_ANONYMOUS_HINT] ? ' or sign-in/register to benefit from a higher export limit.' : '.'
                    }`}</span>
                  </>
                )}
                {errors[EXPORT_ERRORS.RANGE_HIGH_ANONYMOUS_HINT] && (
                  <Button
                    type="button"
                    onClick={signIn}
                    buttonConfig={{
                      label: 'Sign in',
                      type: 'primary',
                      size: 'sm',
                      e2eName: 'export-modal-content-sign-in',
                    }}
                    iconConfig={{
                      name: 'chevron-right',
                    }}
                  />
                )}
              </>
            )}
            {errors[EXPORT_ERRORS.RANGE_EMPTY] && <span>This range selected cannot be zero.</span>}
          </div>

          {range.selected === 2 && (
            <div className="exportModal__ranges_options">
              <div className="exportModal__ranges_options_inputs">
                <Input
                  id="exportModal-content-range-from-input"
                  type="number"
                  name="exportModal-content-range-from-input"
                  classNameInput="e2e-exportModal-content-range-from-input"
                  animatedPlaceholder
                  placeholder="From"
                  value={range.from}
                  onChange={(value) => setRangeOptions('from', value)}
                  required
                  clearButton={false}
                  onBlur={trackAdobeAnalyticsError}
                />
                <Input
                  id="exportModal-content-range-to-input"
                  type="number"
                  name="exportModal-content-range-to-input"
                  classNameInput="e2e-exportModal-content-range-to-input"
                  animatedPlaceholder
                  placeholder="To"
                  value={range.to}
                  onChange={(value) => setRangeOptions('to', value)}
                  clearButton={false}
                  required
                  onBlur={trackAdobeAnalyticsError}
                />
              </div>
              {errors[EXPORT_ERRORS.RANGE_FROM_TO] && (
                <div className="exportModal__ranges_options_message errorMessage text-danger">This range is invalid.</div>
              )}
            </div>
          )}
        </div>
        <div className="exportModal__content_row_tooltip">
          <ExportModalContentTooltip header="Range" text={data.exportSizeTooltip} />
        </div>
      </div>
    </div>
  );
}

ExportModalContentRange.propTypes = {
  data: PropTypes.object,
  formData: PropTypes.object,
  errors: PropTypes.object,
  parentParams: PropTypes.object,
  setRange: PropTypes.func.isRequired,
  setRangeOptions: PropTypes.func.isRequired,
  trackAdobeAnalyticsError: PropTypes.func.isRequired,
  signIn: PropTypes.func.isRequired,
};

export default ExportModalContentRange;
